export default {
  settings: {
    _tag: 'CSidebarNavItem',
    name: 'settings',
    phrase: 'nav-settings',
    to: '/settings',
    order: 11,
    icon: 'fa-regular fa-cog',
    roles: ['Admin'],
  },
}
